module.exports = __webpack_public_path__ + "img/ic_plus.d4f67c1d.svg";